import React, { Component } from "react";
import { connect } from "react-redux";
import { Base } from "zina-dogi-react";
import { CpoTable, CpoFilter } from "../components";
import * as cpo from "../redux";
import "./cpo_list.container.scss";

class CpoList extends Component {
    componentDidMount() {
        this.props.getAll(true);
    }

    render() {
        const { cpos, pagination, changePage, loading, extraProps } = this.props;
        const base_op = {
            className: "cpo_list",
            title: "CPO Inbox",
            breadcrumbs: [{ name: "Home", rel: "/", icon: "home" }, { name: "CPO Inbox" }],
            extraProps,
            loading
        };
        const cpoTable_op = {
            cpos,
            pagination: {
                ...pagination,
                changePage
            },
            className: "cpo_table"
        };
        return (
            <Base {...base_op}>
                <CpoFilter className="filters" onSubmit={this.onFilter} fields={this.props.fields} />
                <CpoTable {...cpoTable_op} />
            </Base>
        );
    }

    onFilter = filters => {
        return this.props.changeFilters(filters);
    };
}

const mapStateToProps = store => ({
    fields: store.cpo.fields,
    cpos: store.cpo.list,
    loading: store.cpo.loading,
    loaded: store.cpo.loaded,
    pagination: store.cpo.pagination
});
const mapDispatchToProps = dispatch => ({
    getAll: format_result => dispatch(cpo.actions.getAll(format_result)),
    changePage: page => dispatch(cpo.actions.changePage(page, true)),
    changeFilters: filters => dispatch(cpo.actions.updateFilter(filters, true))
});
export default connect(mapStateToProps, mapDispatchToProps)(CpoList);
